import type { NftMiniature } from "@anaconda/core/nft/types"
import { Trans } from "@lingui/react/macro"
import { AppToast, SuccessViewTransaction } from "./app-toast"
import { useToastError } from "./toast-util"

export const TransferItemToast = {
  Error: function TransferItemError({
    nft,
    id,
    error,
  }: { nft: NftMiniature; id: string | number; error: unknown }) {
    const { message, type } = useToastError(error, nft.collection.blockchain)

    if (type === "destructive") {
      const errorMessage = "Error during transfer!"
      return (
        <AppToast.Error
          title={errorMessage}
          second={null}
          id={id}
          main={<Trans>{message}</Trans>}
        />
      )
    }
  },

  Success: function BuyToastSuccess({
    id,
    transactionId,
  }: {
    id: string | number
    transactionId?: string
  }) {
    const message = "You've successfully transferred token to another address"
    return (
      <AppToast.Success
        id={id}
        title={message}
        main={null}
        second={<Trans>{message}</Trans>}
      />
    )
  },
}
